import { registerApplication, start } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";
//@ts-ignore
import { ConfigModule } from "@built/config-utility";
// @ts-ignore
import { amplifyInit } from "@built/auth-utility";

const routes = constructRoutes(
  document.querySelector("#single-spa-layout") as HTMLTemplateElement
);

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});
const layoutEngine = constructLayoutEngine({ routes, applications });

applications.forEach(registerApplication);
layoutEngine.activate();

const initOrchestrator = async () => {
  try {
    await ConfigModule.loadConfig();
    const nativConfig = ConfigModule.getNativConfig();
    const authConfig = {
      ...nativConfig?.cognito,
      cookieStorage: {
        ...nativConfig?.cookies,
      },
    } as any;
    await amplifyInit(authConfig);
  } catch (error) {
    console.error("Error initializing config: ", error);
    return Promise.resolve();
  }
};

initOrchestrator().then(() => {
  //@ts-ignore
  start();
});
